
import { useEffect, useState, useRef } from 'react';


interface AirportTextProps {
    text: string;
    className?: string;
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 .!?-';

export function AirportText({ text, className }: AirportTextProps) {
    const [displayText, setDisplayText] = useState('');
    const intervalRef = useRef<any>(null);

    useEffect(() => {
        let iteration = 0;
        const maxIterations = 15; // How many shuffles before settling

        clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            setDisplayText(() => {
                // Build the current string based on iteration
                return text
                    .split('')
                    .map((char, index) => {
                        // If we've passed the iteration for this char, show real char
                        if (index < iteration / 3) { // /3 controls speed of reveal from left to right
                            return char;
                        }
                        // Otherwise show random char
                        return ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
                    })
                    .join('');
            });

            iteration += 1; // Speed of cycling

            // End condition
            if (iteration > (text.length * 3) + maxIterations) { // Ensure clear end
                setDisplayText(text); // Snap to final
                clearInterval(intervalRef.current);
            }
        }, 50); // Speed of flap update

        return () => clearInterval(intervalRef.current);
    }, [text]);

    return (
        <span className={`font-mono tracking-widest uppercase ${className}`}>
            {displayText}
        </span>
    );
}
